(() => {
  const root = document.documentElement;
  root.classList.add('kz-scroll-reveal-loaded');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = [
    '.kz-hero__heading',
    '.kz-hero__subtext',
    '.kz-hero__actions',
    '.kz-pain__item',
    '.kz-pain__quote',
    '.kz-bento__heading',
    '.kz-bento__label',
    '.kz-products__header > div',
    '.kz-tech__content',
    '.kz-tech__card',
    '.kz-trust__item',
    '.kz-blog__heading',
    '.kz-blog__card',
    '.kz-col-hero__inner > div:first-child',
    '.kz-col-segment',
    '.kz-col-cta__content',
    '.kryozon-contact__card'
  ];
  let lastScrollY = window.scrollY;
  let scrollDirection = 'down';

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY !== lastScrollY) {
      scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
      lastScrollY = currentScrollY;
    }
  }, { passive: true });

  const revealTargets = () => {
    const targets = [...document.querySelectorAll(selectors.join(','))];

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const sectionCounts = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            entry.target.classList.remove('is-visible', 'is-static');
            return;
          }

          if (scrollDirection === 'down') {
            entry.target.classList.remove('is-static');
          } else {
            entry.target.classList.add('is-static');
          }

          entry.target.classList.add('is-visible');
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    targets.forEach((target) => {
      const section = target.closest('section, .kz-col-page') || document.body;
      const order = sectionCounts.get(section) || 0;
      sectionCounts.set(section, order + 1);
      target.classList.add('kz-scroll-reveal');
      target.style.setProperty('--kz-reveal-order', Math.min(order, 3));
      observer.observe(target);
    });
  };

  revealTargets();
})();
